<script lang="ts">
    import Chart from 'chart.js/auto'
    import ChartDataLabels from 'chartjs-plugin-datalabels'
    // @ts-ignore - funnel-graph-js não publica types
    import FunnelGraph from 'funnel-graph-js/dist/js/funnel-graph.js'
    import 'funnel-graph-js/dist/css/main.min.css'
    import 'funnel-graph-js/dist/css/theme.min.css'
    import { onMount } from 'svelte/internal'
    import type { Person } from '../../modules/eventsApi/persons/person'
    import { PersonsRepository } from '../../modules/eventsApi/persons/persons.repository'
    import { PersonsService } from '../../modules/eventsApi/persons/persons.service'
    import { InvoicesRepository } from '../../modules/posApi/invoices/invoices.repository'
    import { InvoicesService } from '../../modules/posApi/invoices/invoices.service'
    import { ServicesRepository } from '../../modules/posApi/services/services.repository'
    import { ServicesService } from '../../modules/posApi/services/services.service'
    import { AppointmentsRepository } from '../../modules/schedulerApi/appointments/appointments.repository'
    import { AppointmentsService } from '../../modules/schedulerApi/appointments/appointments.service'
    import { CompaniesRepository } from '../../modules/usersApi/companies/companies.repository'
    import { CompaniesService } from '../../modules/usersApi/companies/companies.service'
    import type { User } from '../../modules/usersApi/users/user'
    import DateSelect from '../_common/date-select.svelte'
    import LoadSpinner from '../_common/load-spinner.svelte'
    import Zact from '../_common/z/zact.svelte'
    import ZContainer from '../_common/z/z-container.svelte'
    import Zframe from '../_common/z/zframe.svelte'
    import type { Invoice, ServicesOnInvoices } from '../../modules/posApi/invoices/invoice'

    const rInvoices = new InvoicesRepository()
    const sInvoices = new InvoicesService(rInvoices)

    let rAppointments = new AppointmentsRepository()
    let sAppointments = new AppointmentsService(rAppointments)

    let personsR = new PersonsRepository()
    let personsS = new PersonsService(personsR)

    const compR = new CompaniesRepository()
    const compS = new CompaniesService(compR)

    let servicesR = new ServicesRepository()
    let servicesS = new ServicesService(servicesR)

    let dates: { from: Date; to: Date } = window.api.utils.dates.currentMonth()

    let containerFunil: HTMLDivElement
    let containerNoShow: HTMLCanvasElement
    let containerConversion: HTMLCanvasElement
    let containerVolume: HTMLCanvasElement
    let containerTempo: HTMLCanvasElement
    let containerMatriz: HTMLCanvasElement
    let containerParticipacao: HTMLCanvasElement
    let containerRadar: HTMLCanvasElement
    let containerValues: HTMLCanvasElement
    let containerQuantities: HTMLCanvasElement
    let show

    let charts: Chart[] = []
    const MUTED = '#666'
    const GRID = '#555'
    const PALETTE = ['#008FFB', '#379E75', '#FEB019', '#775DD0', '#6179F3', '#D0483E', '#9AA0A6']

    function dateChanged(event) {
        dates = event.detail
        getData()
    }

    async function getData() {
        try {
            show = true
            let invoices = []
            let futureInvoices = []
            let persons: Person[] = []
            let users: User[] = []

            // get invoices
            invoices = await sInvoices.getAll({
                from: dates.from,
                to: dates.to,
                service: true,
                status: ['closed', 'subsidized', 'partial', 'open', 'credit'],
            })
            // get future invoices (conversion window)
            let from = new Date(dates.from)
            from.setDate(from.getDate() + 1)
            let to = new Date(dates.to)
            to.setDate(to.getDate() + 31)
            futureInvoices = await sInvoices.getAll({
                from: from,
                to: to,
                service: true,
                status: ['closed', 'subsidized', 'partial', 'open', 'credit'],
            })
            // get consultings
            const services = await servicesS.getAll({ consulting: true })
            let consultingServicesId = []
            for (const service of services) {
                consultingServicesId.push(service.serviceId)
            }
            const consultings = await sAppointments.getConsulting(dates.from, dates.to, consultingServicesId)
            // get persons
            persons = []
            let personsId = []
            for (const invoice of invoices) {
                personsId.push(invoice.personId)
            }
            for (const invoice of futureInvoices) {
                personsId.push(invoice.personId)
            }
            for (const appointment of consultings) {
                personsId.push(appointment.personId)
            }
            personsId = personsId.filter((v, i, a) => a.indexOf(v) === i)
            if (personsId.length > 0) {
                for (let i = 0; i < personsId.length; i += 100) {
                    const chunk = personsId.slice(i, i + 100)
                    persons = persons.concat(await personsS.getAll({ persons: chunk.join(',') }))
                }
            }
            // get company users
            users = await compS.getCompanyUsers()
            // hidrating (hidratar consultings / buscar 30 dias àfrente de vendas para ver conversões futuras)
            for (let invoice of invoices) {
                invoice.person = persons.find((el) => el.personId === invoice.personId)
                invoice.user = users.find((el) => el.userId === invoice?.userId)
                for (let service of invoice.services) {
                    service.user = users.find((el) => el.userId === service?.userId)
                }
            }
            for (let invoice of futureInvoices) {
                invoice.person = persons.find((el) => el.personId === invoice.personId)
                invoice.user = users.find((el) => el.userId === invoice?.userId)
                for (let service of invoice.services) {
                    service.user = users.find((el) => el.userId === service?.userId)
                }
            }
            for (let consulting of consultings) {
                consulting.person = persons.find((el) => el.personId === consulting.personId)
                consulting.user = users.find((el) => el.userId === consulting?.userId)
            }
            console.log('data', invoices, consultings)

            charts.forEach((c) => c.destroy())
            charts = []

            generateFunil(invoices, futureInvoices, consultings, users)
            generateNoShow(consultings, users)
            generateConversion(invoices, futureInvoices, consultings, users)
            generateVolume(consultings, users)
            generateTempoConversao(invoices, futureInvoices, consultings)
            generateMatriz(invoices, futureInvoices, consultings, users)
            generateParticipacao(invoices, users)
            generateRadar(invoices, users)
            generateValues(invoices, users)
            generateQuantities(invoices, users)
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function removeDuplicates(myArr, prop) {
        return myArr.filter((obj, pos, arr) => {
            return arr.map((mapObj) => mapObj[prop]).indexOf(obj[prop]) === pos
        })
    }

    function currency(val: number) {
        return window.configs.currency + Number(val || 0).toFixed(2)
    }

    function hexToRgba(hex: string, alpha: number) {
        const n = parseInt(hex.replace('#', ''), 16)
        return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${alpha})`
    }

    function daysBetween(a: Date, b: Date) {
        const start = new Date(a)
        start.setHours(0, 0, 0, 0)
        const end = new Date(b)
        end.setHours(0, 0, 0, 0)
        return Math.round((end.getTime() - start.getTime()) / 86400000)
    }

    function getItemsFromUser(userId: string, invoices: Invoice[]) {
        let result: { invoiceId: string; total: number; quantity: number; services: ServicesOnInvoices[] }[] = []
        for (const invoice of invoices) {
            if (!invoice.services.some((el) => el.userId === userId)) continue
            result.push({ invoiceId: invoice.invoiceId, total: 0, quantity: 0, services: [] })
            for (const service of invoice.services) {
                if (service.userId !== userId) continue
                result[result.length - 1].total += service.value * service.quantity
                result[result.length - 1].quantity += service.quantity
                result[result.length - 1].services.push(service)
            }
        }
        return result
    }

    // taxa de presença (no-show): entre as avaliações agendadas de cada vendedor, quantas tiveram comparecimento
    async function generateNoShow(consultings, users: User[]) {
        let rows = users
            .map((user) => {
                const userConsultings = consultings.filter((el) => el.userId === user.userId)
                const total = userConsultings.filter((el) => el.status !== 'agendamento_excluido').length
                const compareceu = userConsultings.filter((el) => el.status === 'agendamento_compareceu').length
                return { label: user.userName, total, percent: total === 0 ? 0 : Number(((100 / total) * compareceu).toFixed(0)) }
            })
            .filter((r) => r.total > 0)
            .sort((a, b) => b.percent - a.percent)

        const chart = new Chart(containerNoShow, {
            type: 'bar',
            data: {
                labels: rows.map((r) => r.label),
                datasets: [{ label: 'Presença', data: rows.map((r) => r.percent), backgroundColor: '#008FFB', borderRadius: 4 }],
            },
            options: {
                indexAxis: 'y',
                responsive: true,
                maintainAspectRatio: false,
                // reserva espaço à direita da área de plotagem para o datalabel da barra mais longa não ficar cortado
                layout: { padding: { right: 40 } },
                plugins: {
                    legend: { display: false },
                    tooltip: { callbacks: { label: (ctx) => ctx.parsed.x + '%' } },
                    datalabels: { anchor: 'end', align: 'end', color: MUTED, formatter: (val) => val + '%' },
                },
                scales: {
                    x: { grid: { display: false }, ticks: { color: MUTED } },
                    y: { grid: { display: false }, ticks: { color: MUTED } },
                },
            },
            plugins: [ChartDataLabels],
        })
        charts.push(chart)
    }

    // funil consolidado do time, segmentado por vendedor (biblioteca funnel-graph-js, não Chart.js).
    // cada segmento usa a mesma cor nas 3 etapas, então dá pra acompanhar visualmente onde cada
    // vendedor perde gente no funil (agendou mas não veio, veio mas não converteu)
    async function generateFunil(invoices: Invoice[], futureInvoices: Invoice[], consultings, users: User[]) {
        const totalInvoices = invoices.concat(futureInvoices)

        let rows = users
            .map((user) => {
                const userConsultingsAll = consultings.filter((el) => el.userId === user.userId && el.status !== 'agendamento_excluido')
                const userConsultingsShow = userConsultingsAll.filter((el) => el.status === 'agendamento_compareceu')
                const showPersonIds = userConsultingsShow.map((el) => el.personId)
                const convertido = removeDuplicates(
                    totalInvoices.filter((el) => el.services.find((u) => u.userId === user.userId) && showPersonIds.includes(el.personId)),
                    'personId',
                ).length
                return { label: user.userName, agendado: userConsultingsAll.length, compareceu: userConsultingsShow.length, convertido }
            })
            .filter((r) => r.agendado > 0)
            .sort((a, b) => b.agendado - a.agendado)

        containerFunil.innerHTML = ''
        if (rows.length === 0) return

        const colors = rows.map((_, i) => PALETTE[i % PALETTE.length])

        const graph = new FunnelGraph({
            container: '#conversoes-funil',
            direction: 'horizontal',
            gradientDirection: 'horizontal',
            displayPercent: true,
            data: {
                labels: ['Agendado', 'Compareceu', 'Converteu'],
                subLabels: rows.map((r) => r.label),
                colors,
                values: [rows.map((r) => r.agendado), rows.map((r) => r.compareceu), rows.map((r) => r.convertido)],
            },
        })
        graph.draw()
    }

    // volume de avaliações realizadas: complementa as taxas de presença/conversão com o tamanho da amostra
    async function generateVolume(consultings, users: User[]) {
        let rows = users
            .map((user) => ({
                label: user.userName,
                qtde: consultings.filter((el) => el.userId === user.userId && el.status === 'agendamento_compareceu').length,
            }))
            .filter((r) => r.qtde > 0)
            .sort((a, b) => b.qtde - a.qtde)

        const chart = new Chart(containerVolume, {
            type: 'bar',
            data: {
                labels: rows.map((r) => r.label),
                datasets: [{ label: 'Avaliações realizadas', data: rows.map((r) => r.qtde), backgroundColor: '#008FFB', borderRadius: 4 }],
            },
            options: {
                indexAxis: 'y',
                responsive: true,
                maintainAspectRatio: false,
                // reserva espaço à direita da área de plotagem para o datalabel da barra mais longa não ficar cortado
                layout: { padding: { right: 30 } },
                plugins: {
                    legend: { display: false },
                    datalabels: { anchor: 'end', align: 'end', color: MUTED },
                },
                scales: {
                    x: { grid: { display: false }, ticks: { color: MUTED } },
                    y: { grid: { display: false }, ticks: { color: MUTED } },
                },
            },
            plugins: [ChartDataLabels],
        })
        charts.push(chart)
    }

    // tempo entre a avaliação (compareceu) e a primeira venda subsequente da mesma pessoa
    async function generateTempoConversao(invoices: Invoice[], futureInvoices: Invoice[], consultings) {
        const totalInvoices = invoices.concat(futureInvoices)
        const compareceram = consultings.filter((el) => el.status === 'agendamento_compareceu')

        let dias: number[] = []
        for (const item of compareceram) {
            const matching = totalInvoices
                .filter((inv) => inv.personId === item.personId && new Date(inv.createdAt) >= new Date(item.start))
                .sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime())
            if (matching.length === 0) continue
            const diff = daysBetween(new Date(item.start), new Date(matching[0].createdAt))
            if (diff >= 0) dias.push(diff)
        }

        const buckets = [
            { label: 'Mesmo dia', min: 0, max: 0, color: '#379E75' },
            { label: '1 a 7 dias', min: 1, max: 7, color: '#8BC34A' },
            { label: '8 a 15 dias', min: 8, max: 15, color: '#FEB019' },
            { label: '16 a 31 dias', min: 16, max: 31, color: '#FF8C42' },
        ]
        const data = buckets.map((b) => dias.filter((d) => d >= b.min && d <= b.max).length)

        const chart = new Chart(containerTempo, {
            type: 'bar',
            data: {
                labels: buckets.map((b) => b.label),
                datasets: [{ label: 'Conversões', data, backgroundColor: buckets.map((b) => b.color), borderRadius: 4 }],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    datalabels: { anchor: 'end', align: 'end', color: MUTED },
                },
                scales: {
                    x: { grid: { display: false }, ticks: { color: MUTED } },
                    y: { grid: { display: false }, ticks: { display: false } },
                },
            },
            plugins: [ChartDataLabels],
        })
        charts.push(chart)
    }

    // matriz volume x conversão x valor: identifica quem tem volume e converte bem (referência),
    // quem converte bem mas tem pouco volume (precisa de mais oportunidades) e quem tem volume
    // mas converte pouco (precisa de treinamento de fechamento)
    async function generateMatriz(invoices: Invoice[], futureInvoices: Invoice[], consultings, users: User[]) {
        const totalInvoices = invoices.concat(futureInvoices)
        let rows = users.map((user) => {
            const userConsultingsShow = consultings.filter((el) => el.userId === user.userId && el.status === 'agendamento_compareceu')
            const showPersonIds = userConsultingsShow.map((el) => el.personId)
            const convertido = removeDuplicates(
                totalInvoices.filter((el) => el.services.find((u) => u.userId === user.userId) && showPersonIds.includes(el.personId)),
                'personId',
            ).length
            const valor = getItemsFromUser(user.userId, invoices).reduce((total, el) => total + el.total, 0)
            return {
                label: user.userName,
                volume: userConsultingsShow.length,
                percent: userConsultingsShow.length === 0 ? 0 : (100 / userConsultingsShow.length) * convertido,
                valor,
            }
        })
        rows = rows.filter((r) => r.volume > 0)
        if (rows.length === 0) return

        const maxValor = Math.max(1, ...rows.map((r) => r.valor))
        const points = rows.map((r) => ({
            x: r.volume,
            y: Number(r.percent.toFixed(0)),
            r: 6 + (r.valor / maxValor) * 22,
            label: r.label,
            valor: r.valor,
        }))

        const chart = new Chart(containerMatriz, {
            type: 'bubble',
            data: { datasets: [{ data: points, backgroundColor: hexToRgba('#008FFB', 0.55), borderColor: '#008FFB' }] },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        callbacks: {
                            label: (ctx) => {
                                const p = ctx.raw as { x: number; y: number; label: string; valor: number }
                                return p.label + ': ' + p.x + ' avaliações, ' + p.y + '% conversão, ' + currency(p.valor)
                            },
                        },
                    },
                    datalabels: {
                        color: MUTED,
                        font: { size: 10 },
                        anchor: 'end',
                        align: 'top',
                        offset: 2,
                        formatter: (_, ctx) => (ctx.dataset.data[ctx.dataIndex] as any).label,
                    },
                },
                scales: {
                    x: {
                        title: { display: true, text: 'Avaliações realizadas', color: MUTED },
                        beginAtZero: true,
                        ticks: { color: MUTED, precision: 0 },
                        grid: { color: hexToRgba('#999999', 0.15) },
                    },
                    y: {
                        title: { display: true, text: 'Taxa de conversão (%)', color: MUTED },
                        min: 0,
                        ticks: { color: MUTED },
                        grid: { color: hexToRgba('#999999', 0.15) },
                    },
                },
            },
            plugins: [ChartDataLabels],
        })
        charts.push(chart)
    }

    async function generateConversion(invoices, futureInvoices, consultings, users: User[]) {
        const totalInvoices = invoices.concat(futureInvoices)
        let rows = []
        for (const user of users) {
            const userConsultings = consultings.filter((el) => el.userId === user.userId && el.status === 'agendamento_compareceu').map((el) => el.personId)
            const consulting = userConsultings.length
            const invoice = removeDuplicates(
                totalInvoices.filter((el) => el.services.find((u) => u.userId === user.userId) && userConsultings.includes(el.personId)),
                'personId',
            ).length
            if (invoice > 0) {
                rows.push({ label: user.userName, percent: consulting === 0 ? 0 : Number(((100 / consulting) * invoice).toFixed(0)) })
            }
        }
        rows.sort((a, b) => b.percent - a.percent)

        const chart = new Chart(containerConversion, {
            type: 'bar',
            data: {
                labels: rows.map((r) => r.label),
                datasets: [{ label: 'Conversão', data: rows.map((r) => r.percent), backgroundColor: '#008FFB', borderRadius: 4 }],
            },
            options: {
                indexAxis: 'y',
                responsive: true,
                maintainAspectRatio: false,
                // reserva espaço à direita da área de plotagem para o datalabel da barra mais longa não ficar cortado
                layout: { padding: { right: 40 } },
                plugins: {
                    legend: { display: false },
                    tooltip: { callbacks: { label: (ctx) => ctx.parsed.x + '%' } },
                    datalabels: { anchor: 'end', align: 'end', color: MUTED, formatter: (val) => val + '%' },
                },
                scales: {
                    x: { grid: { display: false }, ticks: { color: MUTED } },
                    y: { grid: { display: false }, ticks: { color: MUTED } },
                },
            },
            plugins: [ChartDataLabels],
        })
        charts.push(chart)
    }

    async function generateParticipacao(invoices: Invoice[], users: User[]) {
        let rows = users.map((user) => ({
            label: user.userName,
            total: getItemsFromUser(user.userId, invoices).reduce((total, el) => total + el.total, 0),
        }))
        rows = rows.filter((r) => r.total > 0).sort((a, b) => b.total - a.total)
        const totalGeral = rows.reduce((t, r) => t + r.total, 0)

        const chart = new Chart(containerParticipacao, {
            type: 'doughnut',
            data: {
                labels: rows.map((r) => r.label),
                datasets: [
                    {
                        data: rows.map((r) => (totalGeral > 0 ? Number(((100 / totalGeral) * r.total).toFixed(1)) : 0)),
                        backgroundColor: rows.map((_, i) => PALETTE[i % PALETTE.length]),
                        borderColor: 'transparent',
                        borderWidth: 2,
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { position: 'top', labels: { color: MUTED } },
                    tooltip: { callbacks: { label: (ctx) => ctx.label + ': ' + ctx.parsed.toFixed(1) + '%' } },
                    datalabels: { color: '#fff', font: { size: 11, weight: 'bold' }, formatter: (val) => (val >= 5 ? val.toFixed(1) + '%' : '') },
                },
            },
            plugins: [ChartDataLabels],
        })
        charts.push(chart)
    }

    async function generateRadar(invoices: Invoice[], users: User[]) {
        let rows = users.map((user) => {
            const filtered = getItemsFromUser(user.userId, invoices)
            const qtde = filtered.length
            const valor = filtered.reduce((total, el) => total + el.total, 0)
            const quantidade = filtered.reduce((total, el) => total + el.quantity, 0)
            return { label: user.userName, ticket: qtde === 0 ? 0 : valor / qtde, quantidade, valor }
        })
        rows = rows
            .filter((r) => r.valor > 0)
            .sort((a, b) => b.valor - a.valor)
            .slice(0, 5)
        if (rows.length === 0) return

        const normalize = (values: number[]) => {
            const max = Math.max(...values, 1)
            return values.map((v) => Number(((v / max) * 100).toFixed(1)))
        }

        const chart = new Chart(containerRadar, {
            type: 'radar',
            data: {
                labels: rows.map((r) => r.label),
                datasets: [
                    {
                        label: 'Ticket médio',
                        data: normalize(rows.map((r) => r.ticket)),
                        borderColor: '#008FFB',
                        backgroundColor: 'rgba(0,143,251,0.15)',
                        pointRadius: 3,
                        borderWidth: 2,
                    },
                    {
                        label: 'Quantidade',
                        data: normalize(rows.map((r) => r.quantidade)),
                        borderColor: '#FEB019',
                        backgroundColor: 'rgba(254,176,25,0.15)',
                        pointRadius: 3,
                        borderWidth: 2,
                    },
                    {
                        label: 'Valor total',
                        data: normalize(rows.map((r) => r.valor)),
                        borderColor: '#379E75',
                        backgroundColor: 'rgba(55,158,117,0.15)',
                        pointRadius: 3,
                        borderWidth: 2,
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { position: 'top', labels: { color: MUTED } },
                    tooltip: { callbacks: { label: (ctx) => ctx.dataset.label + ': ' + ctx.parsed.r.toFixed(0) + ' / 100' } },
                },
                scales: {
                    r: {
                        min: 0,
                        max: 100,
                        ticks: { display: false, backdropColor: 'transparent' },
                        grid: { color: GRID },
                        angleLines: { color: GRID },
                        pointLabels: { color: MUTED },
                    },
                },
            },
        })
        charts.push(chart)
    }

    async function generateValues(invoices: Invoice[], users: User[]) {
        let rows = users.map((user) => ({
            label: user.userName,
            total: getItemsFromUser(user.userId, invoices).reduce((total, el) => total + el.total, 0),
        }))
        rows = rows.filter((r) => r.total > 0).sort((a, b) => b.total - a.total)

        const chart = new Chart(containerValues, {
            type: 'bar',
            data: {
                labels: rows.map((r) => r.label),
                datasets: [{ label: 'Valor vendido', data: rows.map((r) => r.total), backgroundColor: '#379E75', borderRadius: 4 }],
            },
            options: {
                indexAxis: 'y',
                responsive: true,
                maintainAspectRatio: false,
                // reserva espaço à direita da área de plotagem para o datalabel da barra mais longa não ficar cortado
                layout: { padding: { right: 60 } },
                plugins: {
                    legend: { display: false },
                    tooltip: { callbacks: { label: (ctx) => currency(ctx.parsed.x) } },
                    datalabels: { anchor: 'end', align: 'end', color: MUTED, formatter: (val) => currency(val) },
                },
                scales: {
                    x: { grid: { display: false }, ticks: { color: MUTED } },
                    y: { grid: { display: false }, ticks: { color: MUTED } },
                },
            },
            plugins: [ChartDataLabels],
        })
        charts.push(chart)
    }

    async function generateQuantities(invoices, users: User[]) {
        let rows = users.map((user) => ({
            label: user.userName,
            quantity: getItemsFromUser(user.userId, invoices).reduce((total, el) => total + el.quantity, 0),
        }))
        rows = rows.filter((r) => r.quantity > 0).sort((a, b) => b.quantity - a.quantity)

        const chart = new Chart(containerQuantities, {
            type: 'bar',
            data: {
                labels: rows.map((r) => r.label),
                datasets: [{ label: 'Vendas', data: rows.map((r) => r.quantity), backgroundColor: '#775DD0', borderRadius: 4 }],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    datalabels: { anchor: 'end', align: 'end', color: MUTED },
                },
                scales: {
                    x: { grid: { display: false }, ticks: { color: MUTED, maxRotation: 45, minRotation: 45 } },
                    y: { grid: { display: false }, ticks: { display: false } },
                },
            },
            plugins: [ChartDataLabels],
        })
        charts.push(chart)
    }

    function evaluateError(error) {
        window.error(error)
    }

    onMount(async () => {
        await getData()
    })
</script>

<div class="base-dash sales-dash">
    <Zact>
        <DateSelect startFrom={dates.from} startTo={dates.to} on:change={dateChanged} />
    </Zact>
    <ZContainer class="h-space">
        <Zframe
            size={12}
            title="Funil de conversão"
            headline="Agendamentos, comparecimentos e conversões (venda em até 31 dias) no período, segmentados por vendedor — cada cor acompanha o mesmo vendedor nas 3 etapas, mostrando onde cada um perde gente no caminho."
        >
            <div class="chart-box" id="conversoes-funil" style="height:440px" bind:this={containerFunil}></div>
        </Zframe>

        <Zframe
            size={6}
            sizeM={12}
            title="Taxa de presença por vendedor"
            headline="Percentual de comparecimento nas avaliações agendadas de cada vendedor. Agendamentos excluídos não entram no cálculo."
        >
            <div class="chart-box chart-box_tall">
                <canvas bind:this={containerNoShow}></canvas>
            </div>
        </Zframe>

        <Zframe
            size={6}
            sizeM={12}
            title="Taxa de conversão por vendedor"
            headline="Percentual de taxa de conversão de cada vendedor. O Zandu identifica todas as avaliações com presença e contabiliza o percentual que realizou ao menos uma compra nos dias seguintes."
        >
            <div class="chart-box chart-box_tall">
                <canvas bind:this={containerConversion}></canvas>
            </div>
        </Zframe>

        <Zframe
            size={6}
            sizeM={12}
            title="Avaliações realizadas por vendedor"
            headline="Quantidade de avaliações com comparecimento por vendedor. Dá contexto às taxas de presença e conversão, que sozinhas escondem o tamanho da amostra."
        >
            <div class="chart-box chart-box_tall">
                <canvas bind:this={containerVolume}></canvas>
            </div>
        </Zframe>

        <Zframe
            size={6}
            sizeM={12}
            title="Tempo até a conversão"
            headline="Entre quem converteu, quantos dias em média se passaram entre a avaliação e a primeira venda subsequente da mesma pessoa."
        >
            <div class="chart-box chart-box_tall">
                <canvas bind:this={containerTempo}></canvas>
            </div>
        </Zframe>

        <Zframe
            size={12}
            title="Matriz de desempenho: volume x conversão x valor"
            headline="Cada bolha é um vendedor: eixo X é a quantidade de avaliações realizadas, eixo Y é a taxa de conversão, e o tamanho da bolha é o valor total vendido. Ajuda a identificar quem tem bom volume e boa conversão (referência), quem converte bem mas tem pouca oportunidade, e quem tem volume mas precisa melhorar o fechamento."
        >
            <div class="chart-box chart-box_tall">
                <canvas bind:this={containerMatriz}></canvas>
            </div>
        </Zframe>

        <Zframe size={6} sizeM={12} title="Participação no valor vendido" headline="Percentual do valor total vendido no período que cada vendedor representa.">
            <div class="chart-box chart-box_tall">
                <canvas bind:this={containerParticipacao}></canvas>
            </div>
        </Zframe>

        <Zframe
            size={6}
            sizeM={12}
            title="Comparativo entre vendedores"
            headline="Compara ticket médio, quantidade e valor vendido dos 5 vendedores com maior faturamento. Os valores são normalizados (0 a 100) para comparar métricas de escalas diferentes."
        >
            <div class="chart-box chart-box_tall">
                <canvas bind:this={containerRadar}></canvas>
            </div>
        </Zframe>

        <Zframe size={6} sizeM={12} title="Valor vendido por vendedor" headline="Valor total vendido por cada vendedor.">
            <div class="chart-box chart-box_tall">
                <canvas bind:this={containerValues}></canvas>
            </div>
        </Zframe>

        <Zframe size={6} title="Quantidade de vendas por vendedor" headline="Quantidade de vendas realizadas por cada vendedor.">
            <div class="chart-box">
                <canvas bind:this={containerQuantities}></canvas>
            </div>
        </Zframe>
    </ZContainer>
</div>
<LoadSpinner delay={300} {show} />

<style>
    .chart-box {
        position: relative;
        width: 100%;
        height: 320px;
    }
    .chart-box_tall {
        height: 360px;
    }

    :global(.theme_light #conversoes-funil .label__value),
    :global(.theme_light #conversoes-funil .svg-funnel-js__subLabel) {
        color: #212529;
    }
    :global(.theme_light #conversoes-funil .label__title) {
        color: #0f9d67;
    }
    :global(.theme_light #conversoes-funil .label__percentage) {
        color: #5b52a3;
    }
</style>
